<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">退款資料</span>
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Refund id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="退款編號："
                  label-for="id"
                  label-cols-md="3"
                >
                  <div class="">
                    {{
                      newRefundData.id
                        ? newRefundData.refund_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_refund_date"
                >
                  <b-form-group
                    label="退款日期："
                    label-for="refund_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newRefundData.refund_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- receipt id -->

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_customer_id"
                >
                  <b-form-group
                    label="客戶："
                    label-for="customer_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="customer_id"
                      v-model="newRefundData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="filteredCustomerOptions"
                      :clearable="false"
                      label="name_cn"
                      :reduce="(option) => option.id"
                      placeholder="選擇客戶"
                      :filter="customerSearch"
                      :disabled="newRefundData.id > 0 || userData.user_type_id == 2"
                    >
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_receipt_id"
                >
                  <b-form-group
                    label="收據編號："
                    label-for="refund-receipt-id"
                    label-cols-md="3"
                  >
                    <v-select
                      id="receipt_id"
                      v-model="newRefundData.receipt_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="filteredReceiptOptions"
                      :clearable="false"
                      label="receipt_number"
                      :reduce="(option) => option.id"
                      :placeholder="!newRefundData.customer_id ? '請先選擇客戶' : '選擇收據'"
                      :filter="receiptSearch"
                      :disabled="!newRefundData.customer_id "
                    >
                  
                    </v-select>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer name_cn-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_cn"
                >
                  <b-form-group
                    label="單據抬頭："
                    label-for="c_name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_name_cn"
                      v-model="newRefundData.name_cn"
                      placeholder="輸入單據抬頭"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer name_en-->
              <b-col cols="12" md="6">
                  <b-form-group
                    label="系統帳號名稱："
                    label-for="c_name_en"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="c_name_cn"
                      v-model="newRefundData.name_en"
                      placeholder="輸入系統帳號名稱"
                    />
                  </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer mobile-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_mobile"
                >
                  <b-form-group
                    label="聯絡電話："
                    label-for="customer_mobile"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="customer_mobile"
                      v-model="newRefundData.mobile"
                      placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer email-->
              <b-col cols="12" md="6">
                  <b-form-group
                    label="電郵地址："
                    label-for="email"
                    label-cols-md="3"
                    class=""
                  >
                    <b-form-input
                      id="customer_email"
                      v-model="newRefundData.email"
                      placeholder="輸入電郵地址"
                    />
                  </b-form-group>
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>

              <!-- project_name -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="項目名稱："
                  label-for="project_name"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="project_name"
                    v-model="newRefundData.project_name"
                    placeholder="輸入項目名稱"
                  />
                </b-form-group>
              </b-col>

              <!-- address -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="施工地址："
                  label-for="address"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="address"
                    v-model="newRefundData.address"
                    placeholder="輸入施工地址"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- refund_items -->
              <b-col cols="12">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <span>退款項目</span>
                </div>

                <b-row
                  v-for="(refund, index) in newRefundData.refund_items"
                  :key="`refund_${index}`"
                  class="px-1"
                >
                  <b-col
                    cols="12"
                    class="d-flex backgroundColor5 mb-1 radius-round border-1"
                  >
                    <b-row class="flex-grow-1 p-2">
                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v-receipt_item_id${index}`"
                          :name="`此欄`"
                          rules="required"
                        >
                          <b-form-group
                            label="收據項目:"
                            :label-for="`receipt_item_id${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                            <v-select
                              :id="`receipt_item_id${index}`"
                              v-model="refund.receipt_item_id"
                              :dir="
                                $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              "
                              :options="receiptItemData"
                              :clearable="false"
                              label="name"
                              :reduce="(option) => option.id"
                              :disabled="!newRefundData.receipt_id"
                              :readonly="!newRefundData.receipt_id"
                              :placeholder="!newRefundData.receipt_id ? '請先選擇收據' : '選擇收據項目'"
                              :filter="receiptItemSearch"
                            >
                              <template
                                #option="{
                                  invoice_number,
                                  step_phase,
                                  step_name,
                                  payment_date,
                                  amount,
                                }"
                              >
                                [{{ invoice_number }}] {{ step_phase }}{{ step_name ? '-' + step_name : '' }} {{ payment_date }} ${{
                                  Number(amount)
                                }}
                              </template>
                              <template
                                #selected-option="{
                                  invoice_number,
                                  step_phase,
                                  step_name,
                                  payment_date,
                                  amount,
                                }"
                              >
                                [{{ invoice_number }}] {{ step_phase }}{{ step_name ? '-' + step_name : '' }} {{ payment_date }} ${{
                                  Number(amount)
                                }}
                              </template>
                            </v-select>
                            <b-form-invalid-feedback
                              :state="getValidationState(validationContext)"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                        <!-- refund-date -->
                        <!-- <validation-provider
                          #default="validationContext"
                          :vid="`v-refund-date${index}`"
                          name="退款日期"
                          rules="required"
                        >
                          <b-form-group
                            label="退款日期"
                            :label-for="`refund-date${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                            <flat-pickr
                              v-model="refund.refund_date"
                              class="form-control"
                              :config="{
                                allowInput: true,
                                altInput: true,
                                altFormat: 'Y-m-d',
                                dateFormat: 'Y-m-d',
                              }"
                              placeholder="輸入YYYY-MM-DD"
                            />
                            <b-form-invalid-feedback
                              :state="getValidationState(validationContext)"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider> -->

                        <!-- amount -->
                        <validation-provider
                          #default="validationContext"
                          :vid="`v-refund-amount${index}`"
                          name="此欄"
                          rules="required"
                        >
                          <b-form-group
                            label="退款金額："
                            :label-for="`refund-amount${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                            <b-form-input
                              :id="`refund-amount${index}`"
                              v-model="refund.amount"
                              :state="getValidationState(validationContext)"
                              @input="calTotalAmount"
                              placeholder="輸入退款金額"
                            />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col cols="12" md="6">
                        <!-- item_description -->
                      
                          <b-form-group
                            label="款項摘要："
                            label-for="item_description"
                            label-cols-md="3"
                          >
                            <textarea
                              v-model="refund.item_description"
                              class="w-100"
                            />
                          </b-form-group>
                      </b-col>
                    </b-row>
                    <div
                      class="d-flex flex-column justify-content-between py-50 px-25"
                    >
                      <feather-icon
                        size="16"
                        icon="PlusIcon"
                        class="cursor-pointer text-success"
                        @click="addItem(index)"
                      />
                      <feather-icon
                        size="16"
                        icon="XIcon"
                        class="cursor-pointer text-danger"
                        @click="removeItem(index, refund.id)"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <!-- amount -->
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <validation-provider
                    #default="validationContext"
                    name="此欄"
                    rules="required"
                    vid="v_amount"
                  >
                    <b-form-group
                      label="總額："
                      label-for="amount"
                      label-cols-md="3"
                      class="require"
                    >
                      <b-form-input
                        id="refund_amount"
                        v-model="newRefundData.amount"
                        placeholder="輸入總額"
                        :state="getValidationState(validationContext)"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </div>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- 圖片上傳 -->
              <b-col cols="12">
                <upload-file
                  key="fileupload1"
                  ref="childRef1"
                  custome_id="1"
                  :props_previewImage="newRefundData.documents"
                  file_delete_url="/finance/refunds/documents"
                  v-on:file-uploaded="onFileUploaded"
                ></upload-file>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
            </b-row>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import { maxDate } from "@/libs/helper.js";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  data() {
    return {
      required,
      email,
      image_files: [],
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
  },
  methods: {
    hide() {
      this.$router.replace("/refunds/list");
    },
    customerSearch(options, search) {
      return options.filter((item) => {
        return (
          // (item.name && item.name.toLowerCase().includes(search.toLowerCase())) ||
          (item.name_cn && item.name_cn.toLowerCase().includes(search.toLowerCase())) ||
          (item.user_number && item.user_number.toLowerCase().includes(search.toLowerCase()))
        );
      });
    },
    receiptSearch(options, search) {
      return options.filter((item) => {
        return item.receipt_number.toLowerCase().includes(search.toLowerCase());
      });
    },
    receiptItemSearch(options, search) {
      return options.filter((item) => {
        return item.item_description.toLowerCase().includes(search.toLowerCase());
      });
    },
    onFileUploaded(files) {
      this.image_files = files;
    },
    onSubmit() {
      // 創建 FormData 對象
      const formData = new FormData();

      // 添加基本表單資料
      const submitData = { ...this.newRefundData };
      Object.keys(submitData).forEach(key => {
        if (key === 'refund_items') {
          // 跳過 refund_items，因為會單獨處理
        } else if (key === 'documents') {
          // 跳過 documents，因為檔案會單獨處理
        } else if (key === 'created_at' || key === 'updated_at' || key === 'receipt' || key === 'customer') {
          // 跳過這些不需要提交的欄位
        } else if (submitData[key] !== null && submitData[key] !== undefined) {
          formData.append(key, submitData[key]);
        }
      });

      // 處理 refund_items 陣列
      if (this.newRefundData.refund_items && this.newRefundData.refund_items.length > 0) {
        for (let i = 0; i < this.newRefundData.refund_items.length; i++) {
          const refundItem = this.newRefundData.refund_items[i];
          for (let key in refundItem) {
            if (refundItem.hasOwnProperty(key)) {
              const value = refundItem[key];
              formData.append(
                `refund_items[${i}][${key}]`,
                value !== undefined && value !== null ? value : ''
              );
            }
          }
        }
      }

      // 添加檔案
      if (this.image_files && this.image_files.length > 0) {
        this.image_files.forEach((item) => {
          formData.append("documents[]", item);
        });
      }

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("refund/editRefund", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.$emit("refetch-data");
              this.hide();

              // if (this.newRefundData.id == 0) {
              //   this.newRefundData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },

    addItem(index) {
      this.newRefundData.refund_items.splice(
        index + 1,
        0,
        JSON.parse(
          JSON.stringify({
            id: 0,
          })
        )
      );
    },
    removeItem(index, id) {
      // check number of record
      let record =
        this.newRefundData &&
        this.newRefundData.refund_items &&
        this.newRefundData.refund_items.length;
      if (record <= 1) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        if (id > 0) {
          this.$swal({
            title: "你確定嗎?",
            text: "您的行動是最終的，您將無法檢索這記錄。",
            showCancelButton: true,
            confirmButtonText: "刪除",
            cancelButtonText: "取消",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              store
                .dispatch("refund/deleteRefundItem", { id })
                .then((response) => {
                  this.$swal({
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "確定",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    showClass: {
                      popup: "animate__animated animate__bounceIn",
                    },
                    buttonsStyling: false,
                  });
                  this.$emit("refetch-data");
                })
                .catch((error) => {
                  this.$swal({
                    text: error.response.data.message,
                    icon: "error",
                    confirmButtonText: "確定",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    showClass: {
                      popup: "animate__animated animate__bounceIn",
                    },
                    buttonsStyling: false,
                  });
                });
            }
          });
        } else {
          this.newRefundData.refund_items.splice(index, 1);
        }
      }
      this.calTotalAmount();
    },
  },
  props: {
    refundData: {
      type: Object,
      required: true,
    },
    receiptOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    /*  costOptions: {
      type: Array,
      required: true,
    }, */
  },

  setup(props, { emit }) {
    // 取得當前登入用戶資料
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');

    const newRefundData = ref({
      id: 0,
      refund_items: [{ id: 0 }],
      documents: [],
    });

    const customer = ref({
      name: "",
      name_en: "",
      mobile: "",
      email: "",
    });

    // 根據用戶類型過濾客戶選項
    const filteredCustomerOptions = computed(() => {
      if (userData.user_type_id === 2) {
        // 客戶類型只能看到自己
        return props.customerOptions.filter(customer => customer.id === userData.id);
      }
      // 其他用戶類型可以看到所有客戶
      return props.customerOptions;
    });

    watch(
      () => props.refundData,
      (newVal) => {
        newRefundData.value = { ...newVal };
      }
    );

    watch(
      () => newRefundData.value.receipt_id,
      (newVal) => {
        if (props.receiptOptions && props.receiptOptions.length > 0) {
          if (!newRefundData.value.id) {
            fetchReceipt(newRefundData.value.receipt_id);
          } else {
            fetchReceiptItem(newRefundData.value.receipt_id);
          }
        }
      }
    );
      const init = ref(true);
    watch(
      () => newRefundData.value.customer_id,
      (newVal) => {
        if(init.value) {
          init.value = false;
          return;
        }
        if (props.customerOptions && props.customerOptions.length > 0) {
          const customer = props.customerOptions.find(
            (ele) => ele.id == newRefundData.value.customer_id
          );
          console.log("customer", customer);
          newRefundData.value.name_cn = customer.name_cn;
          newRefundData.value.name_en = customer.name;
          newRefundData.value.mobile = customer.phone;
          newRefundData.value.email = customer.email;
        }

        // 客戶變更時清空收據相關數據
        if (newRefundData.value.receipt_id) {
          newRefundData.value.receipt_id = null;
          newRefundData.value.project_name = null;
          newRefundData.value.address = null;
          receiptItemData.value = [];
          // 重置退款項目為初始狀態
          newRefundData.value.refund_items = [{ id: 0 }];
          newRefundData.value.amount = 0;
        }
      }
    );

    const resetRefundData = () => {
      newRefundData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          refund_items: [{ id: 0 }],
        })
      );
    };

    const calTotalAmount = () => {
      let total = 0;

      if (
        newRefundData.value.refund_items &&
        newRefundData.value.refund_items.length > 0
      ) {
        total += newRefundData.value.refund_items.reduce(
          (a, b) => a + (Number(b.amount) ? Number(b.amount) : 0),
          0
        );
      }
      newRefundData.value.amount = total;
    };

    const receiptItemData = ref([]);
    const fetchReceiptItem = (id) => {
      store.dispatch("refund/fetchReceipt", { id }).then((response) => {
        const receipt = response.data.receipt;
        receiptItemData.value = receipt && receipt.receipt_items;
      });
    };

    const fetchReceipt = (id) => {
      store
        .dispatch("refund/fetchReceipt", { id })
        .then((response) => {
          const receipt = response.data.receipt;
          newRefundData.value.project_name = receipt.project_name;
          newRefundData.value.customer_id = receipt.customer_id;
          newRefundData.value.name_cn = receipt.name_cn;
          newRefundData.value.name_en = receipt.name_en;
          newRefundData.value.mobile = receipt.mobile;
          newRefundData.value.email = receipt.email;
          newRefundData.value.address = receipt.address;

          receiptItemData.value = receipt && receipt.receipt_items;

          newRefundData.value.refund_items = receiptItemData.value.map(
            (ele) => {
              return {
                refund_date: maxDate,
                amount: ele.amount,
                item_description: ele.item_description || '',
                receipt_item_id: ele.id,
              };
            }
          );
          calTotalAmount();
        })
        .catch((error) => {
          console.log("error when fetching receipt", error);
          if (error.response.status === 404) {
            receiptData.value = undefined;
          }
        });
    };


    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetRefundData);

    const filteredReceiptOptions = computed(() => {
      if (!newRefundData.value.customer_id) {
        return props.receiptOptions;
      }
      return props.receiptOptions.filter(
        (receipt) => receipt.customer_id === newRefundData.value.customer_id
      );
    });

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      newRefundData,
      calTotalAmount,
      receiptItemData,
      // fetchReceipt
      filteredReceiptOptions,
      filteredCustomerOptions,
      userData,
      init,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
